import T_CP_login from 'modules/cp_login/template';

const CP_login = () => {
  return <T_CP_login />;
};

export default CP_login;
